/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Product_Leveling_Member_Roles_ReadInputs */



/**
* | output |
* | --- |
* | "See personal role designs" |
*
* @param {Perm_Product_Leveling_Member_Roles_ReadInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_product_leveling_member_roles_read = /** @type {((inputs?: Perm_Product_Leveling_Member_Roles_ReadInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Product_Leveling_Member_Roles_ReadInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видеть оформление личных ролей")
	return /** @type {LocalizedString} */ ("See personal role designs")
});